import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ApiService } from './api-service';
import { Settings, SettingFlag, SettingValue } from '../models/settings.model';
import { AppSettings } from '../models/app-settings.model';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private api = inject(ApiService);

  private readonly appSettingsSubject = new BehaviorSubject<AppSettings[] | null>(null);
  readonly appSettings$ = this.appSettingsSubject.asObservable();

  loadAllSettings(): Observable<AppSettings[]> {
    return this.api.get<AppSettings[]>('/settings/app/all').pipe(
      tap(settings => this.appSettingsSubject.next(settings))
    );
  }

  getPdfFormatSetting(): Observable<SettingFlag> {
    return this.api.get<SettingFlag>('/settings/format/pdf/enabled');
  }

  getExcelFormatSetting(): Observable<SettingFlag> {
    return this.api.get<SettingFlag>('/settings/format/excel/enabled');
  }

  getDocFormatSetting(): Observable<SettingFlag> {
    return this.api.get<SettingFlag>('/settings/format/doc/enabled');
  }

  getDeletionEnabled(): Observable<SettingFlag> {
    return this.api.get<SettingFlag>('/settings/deletion/enabled');
  }

  getDocumentLimit(): Observable<SettingValue> {
    return this.api.get<SettingValue>('/settings/dimension/limit');
  }

  postPdfFormatSetting(params: Settings): Observable<any> {
    return this.api.post('/settings/format/pdf/enabled', params);
  }

  postExcelFormatSetting(params: Settings): Observable<any> {
    return this.api.post('/settings/format/excel/enabled', params);
  }

  postDocFormatSetting(params: Settings): Observable<any> {
    return this.api.post('/settings/format/doc/enabled', params);
  }

  postDocumentLimitSetting(params: Settings): Observable<any> {
    return this.api.post('/settings/dimension/limit', params);
  }

  postDeletionEnabledSetting(params: Settings): Observable<any> {
    return this.api.post('/settings/deletion/enabled', params);
  }
}
